// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { N0, N50A, N60A } from '@atlaskit/theme/colors';
import { borderRadius } from '@atlaskit/theme/constants';
export var container = function container(height) {
  return css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "".concat(borderRadius(), "px"),
    boxShadow: "var(--ds-shadow-overlay, ".concat("0 12px 24px -6px ".concat(N50A, ", 0 0 1px ").concat(N60A), ")"),
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
    padding: "var(--ds-space-050, 4px)".concat(" ", "var(--ds-space-100, 8px)"),
    backgroundColor: "var(--ds-background-input, ".concat(N0, ")"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: height ? "".concat(height, "px") : undefined
  });
};